import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';

const AdministrationUploadProductIndividualPage = lazy(
	() =>
		import('pages/administration/AdministrationUploadProductIndividualPage')
);
const AdministrationManageQaAccessRequestsPage = lazy(
	() =>
		import('pages/administration/AdministrationManageQaAccessRequestsPage')
);

export const getAdministrationRoutes = () => [
	<Route
		key="upload-product-individual"
		path="UploadProductIndividual"
		element={
			<LazyRouteElement
				area={createArea(AreaName.Individual, OperationType.Write)}
				Component={AdministrationUploadProductIndividualPage}
				path={'UploadProductIndividual'}
			/>
		}
	/>,
	<Route
		key="manage-qa-access-requests"
		path="ManageQaAccessRequests"
		element={
			<LazyRouteElement
				area={createArea(
					AreaName.ManageQaAccessRequests,
					OperationType.Write
				)}
				Component={AdministrationManageQaAccessRequestsPage}
				path={'ManageQaAccessRequests'}
			/>
		}
	/>,
];
